/**
 * Logo period colour — always purple (brand default).
 * Category colours are contextual and apply to section page content,
 * not the logo. See .claude/rules/design_system.md for colour usage rules.
 */

export const LOGO_TEXT_COLOR = '#2C3E50'; // Dark slate gray

/**
 * @returns {string} - Hex colour for the logo period
 */
export const getLogoPeriodColor = () => '#A26ECC';
